// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carttable-placeholder-color::placeholder {
  color: white !important;
}

.carttable-placeholder-color {
  border: none;
  background-color: #0562fb;
}

.carttable-placeholder-color:focus {
  outline: none !important;
}

.active-image-on-new {
  width: 29px !important;
  height: 29px !important;
}

.number-container {
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: var(--blue);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  /* margin-right: 3rem; */
}

.system-health-text {
  color: rgba(13, 98, 251);
  font-size: 13px !important;
  border: 2px solid rgba(13, 98, 251) !important;
  padding: 5px 10px 5px 10px;
  border-radius: 100vw;
  height: 36px;
  background-color: rgba(13, 96, 251, 0.228);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark .system-health-text {
  color: rgba(13, 98, 251);
  border: 2px solid rgba(13, 98, 251) !important;
  background-color: transparent;
}
.cart-table-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.no-offer-number-container{
  background-color: #0563fb;
  color: white;
  opacity: 0.3;
  cursor: not-allowed !important;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  white-space: nowrap;
}

.new-two-way-text{
  color: black;
  font-size: 1rem;
  border: 2px solid black;
  padding: 0.5rem;
  border-radius: 0.5rem;
}

.dark .new-two-way-text{
  color: white;
  border: 2px solid rgb(193, 188, 188);
}

.order-top-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap:10px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/CartTableBar/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8CAA8C;EAC9C,0BAA0B;EAC1B,oBAAoB;EACpB,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".carttable-placeholder-color::placeholder {\n  color: white !important;\n}\n\n.carttable-placeholder-color {\n  border: none;\n  background-color: #0562fb;\n}\n\n.carttable-placeholder-color:focus {\n  outline: none !important;\n}\n\n.active-image-on-new {\n  width: 29px !important;\n  height: 29px !important;\n}\n\n.number-container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  background-color: var(--blue);\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  /* margin-right: 3rem; */\n}\n\n.system-health-text {\n  color: rgba(13, 98, 251);\n  font-size: 13px !important;\n  border: 2px solid rgba(13, 98, 251) !important;\n  padding: 5px 10px 5px 10px;\n  border-radius: 100vw;\n  height: 36px;\n  background-color: rgba(13, 96, 251, 0.228);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark .system-health-text {\n  color: rgba(13, 98, 251);\n  border: 2px solid rgba(13, 98, 251) !important;\n  background-color: transparent;\n}\n.cart-table-bar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.no-offer-number-container{\n  background-color: #0563fb;\n  color: white;\n  opacity: 0.3;\n  cursor: not-allowed !important;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.new-two-way-text{\n  color: black;\n  font-size: 1rem;\n  border: 2px solid black;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n}\n\n.dark .new-two-way-text{\n  color: white;\n  border: 2px solid rgb(193, 188, 188);\n}\n\n.order-top-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap:10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
